/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _script = __webpack_require__(1);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _blazy = __webpack_require__(2);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _jsCookie = __webpack_require__(3);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	__webpack_require__(4);
	
	__webpack_require__(5);
	
	var _viewportUnitsBuggyfill = __webpack_require__(6);
	
	var _viewportUnitsBuggyfill2 = _interopRequireDefault(_viewportUnitsBuggyfill);
	
	__webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*------------------------------*\
		current-menu-item home
		little-form little-form__field little-form__label little-form__input button little-form__error
		little-form__col-1-2
		little-form__row little-form__submit .little-form__select
		custom-select body.bookings .little-form
		.contact__family--horizontal .contact__family--circle
	\*------------------------------*/
	;(function () {
		var throttle = function throttle(type, name, obj) {
			var obj = obj || window;
			var running = false;
			var func = function func() {
				if (running) {
					return;
				}
				running = true;
				requestAnimationFrame(function () {
					obj.dispatchEvent(new CustomEvent(name));
					running = false;
				});
			};
			obj.addEventListener(type, func);
		};
	
		/* init - you can init any event */
		throttle("scroll", "optimizedScroll");
	})();
	
	// matches polyfill
	window.Element && function (ElementPrototype) {
		ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.matchesSelector || ElementPrototype.webkitMatchesSelector || ElementPrototype.msMatchesSelector || function (selector) {
			var node = this,
			    nodes = (node.parentNode || node.document).querySelectorAll(selector),
			    i = -1;
			while (nodes[++i] && nodes[i] != node) {}
			return !!nodes[i];
		};
	}(Element.prototype);
	
	// closest polyfill
	window.Element && function (ElementPrototype) {
		ElementPrototype.closest = ElementPrototype.closest || function (selector) {
			var el = this;
			while (el.matches && !el.matches(selector)) {
				el = el.parentNode;
			}return el.matches ? el : null;
		};
	}(Element.prototype);
	
	(function (window, document, $$, $, _) {
	
		var blazy = new _blazy2.default();
	
		function getNodeIndex(node) {
			var index = 0;
			while (node = node.previousSibling) {
				if (node.nodeType != 3 || !/^\s*$/.test(node.data)) {
					index++;
				}
			}
			return index;
		}
	
		function wrap(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		}
	
		_.ready(function () {
	
			_viewportUnitsBuggyfill2.default.init();
	
			function offset(el) {
				var rect = el.getBoundingClientRect(),
				    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
				    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
			}
	
			/*------------------------------*\
	  	Masonry
	  \*------------------------------*/
			var masonry = $$('.do-masonry');
	
			if (masonry.length) {
	
				(0, _script2.default)('https://cdnjs.cloudflare.com/ajax/libs/packery/1.4.3/packery.pkgd.min.js', function () {
	
					var music = $('div.music');
					if (music) {
						var playTrack = function playTrack(index) {
	
							currentTrack = index;
	
							player.src = tracks[currentTrack];
							player.play();
							isPlaying = true;
	
							_.addClass(needle, 'music__needle--active');
							setTimeout(function () {
								_.addClass(vinyl, 'music__vinyl--active');
								_.removeClass(vinyl, 'music__vinyl--paused');
							}, 800);
	
							_.removeClass(trackList, 'music-track--active');
							_.addClass(trackList[index], 'music-track--active');
	
							_.removeClass(playBtn, 'icon--play');
							_.addClass(playBtn, 'icon--pause');
						};
	
						var playNextTrack = function playNextTrack() {
							currentTrack++;
							if (currentTrack >= tracks.length) {
								currentTrack = 0;
							}
							playTrack(currentTrack);
						};
	
						var player = $('.music-audio');
						var needle = $('.music__needle');
						var vinyl = $('.music__vinyl');
						var isPlaying = false;
	
						// var masonryMusic = new Packery( music, {
						// 	itemSelector: '.music-item',
						// 	columnWidth: '.music__sizer',
						// 	percentPosition: true,
						// 	stamp: '.music__stamp'
						// } );
						// masonryMusic.layout();
	
						var playlist = $('.music__playlist');
						var trackList = $$('.music__playlist a');
						var tracks = [];
						var currentTrack = -1;
	
						for (var i = 0; i < trackList.length; i++) {
							tracks.push(trackList[i].getAttribute('href'));
						}
	
						_.on('click', playlist, 'a', function (e) {
	
							e.preventDefault();
	
							playTrack(getNodeIndex(this.closest('li')));
						});
	
						var playBtn = $('.music__play .icon');
						_.on('click', $('.music__play'), function () {
							_.toggleClass(playBtn, 'icon--play');
							_.toggleClass(playBtn, 'icon--pause');
							if (currentTrack === -1) {
								// start from beginning
								playTrack(0);
							} else if (isPlaying) {
								player.pause();
								isPlaying = false;
								_.removeClass(vinyl, 'music__vinyl--active');
								_.addClass(vinyl, 'music__vinyl--paused');
							} else {
								player.play();
								isPlaying = true;
								_.addClass(vinyl, 'music__vinyl--active');
								_.removeClass(vinyl, 'music__vinyl--paused');
							}
						});
	
						_.on('click', $('.music__stop'), function () {
							player.pause();
							player.removeAttribute('src');
							isPlaying = false;
							currentTrack = -1; // reset
							_.removeClass(needle, 'music__needle--active');
							setTimeout(function () {
								_.removeClass(vinyl, 'music__vinyl--active');
								_.addClass(vinyl, 'music__vinyl--paused');
							}, 800);
							_.removeClass(trackList, 'music-track--active');
	
							_.addClass(playBtn, 'icon--play');
							_.removeClass(playBtn, 'icon--pause');
						});
	
						_.on('click', $('.music__next'), playNextTrack);
						player.addEventListener('ended', playNextTrack);
	
						_.on('click', $('.music__prev'), function () {
							currentTrack--;
							if (currentTrack < 0) {
								currentTrack = tracks.length - 1;
							}
							playTrack(currentTrack);
						});
					}
	
					/*------------------------------*\
	    	Gallery
	    \*------------------------------*/
					var gallery = $('div.gallery');
	
					if (gallery) {
	
						var masonryGallery = new Packery(gallery, {
							itemSelector: '.gallery-item',
							columnWidth: '.gallery__sizer',
							percentPosition: true
						});
	
						masonryGallery.on('layoutComplete', function (items) {
	
							blazy.revalidate();
						});
					}
				});
			}
	
			/*------------------------------*\
	  	Nav
	  \*------------------------------*/
			var nav = $('.nav-main');
			var navToggle = $('.nav-main__toggle a');
			var mobileTop = $('.mobile-top');
	
			_.on('click', navToggle, function (e) {
	
				e.preventDefault();
	
				_.toggleClass(nav, 'nav-main--active');
				_.toggleClass(mobileTop, 'mobile-top--active');
			});
	
			/*------------------------------*\
	  	Cat
	  \*------------------------------*/
			if ($('body.home')) {
	
				var cat = $('.header__cat');
				var catFixed = cat.cloneNode(true);
				_.addClass(catFixed, 'header__cat--fixed');
				_.removeClass(catFixed, 'header__cat--main');
				_.removeClass(catFixed, 'header__cat--active');
	
				cat.parentNode.appendChild(catFixed);
	
				var catTop = offset(cat).top;
				var catMiddle = catTop + cat.offsetHeight / 2;
	
				window.addEventListener('optimizedScroll', function () {
	
					if (window.scrollY > catMiddle) {
	
						_.removeClass(cat, 'header__cat--active');
						_.addClass(catFixed, 'header__cat--active');
					} else {
	
						_.addClass(cat, 'header__cat--active');
						_.removeClass(catFixed, 'header__cat--active');
					}
				});
			}
	
			/*------------------------------*\
	  	Date Picker
	  \*------------------------------*/
			var bookingDate = $('.booking-date input');
			var bookingTime = $('.booking-time input');
	
			if (bookingDate) {
	
				(0, _script2.default)('https://cdnjs.cloudflare.com/ajax/libs/rome/2.1.22/rome.min.js', function () {
	
					function pad(n, width, z) {
						z = z || '0';
						n = n + '';
						return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
					}
	
					var d = new Date();
					console.log(rome.moment().format('Do MMM'));
	
					rome(bookingDate, {
						time: false,
						inputFormat: 'Do MMM',
						weekStart: 1,
						min: rome.moment().format('Do MMM'),
						styles: {
							container: 'rd-container rd-container--date'
						}
					});
	
					rome(bookingTime, { date: false });
				});
			}
	
			/*------------------------------*\
	  	Custom Select
	  \*------------------------------*/
			var select = $$('.little-form__select select');
	
			if (select.length) {
	
				for (var s = 0; s < select.length; s++) {
	
					var wrapper = document.createElement('div');
					wrapper.className = 'custom-select';
	
					wrap(select[s], wrapper);
				}
			}
	
			/*------------------------------*\
	  	Contact Family
	  \*------------------------------*/
			var contactFamily = $('.contact__family');
			function updateFamily() {
				if (_.windowWidth() < 1000) {
					_.removeClass(contactFamily, 'contact__family--horizontal');
					_.addClass(contactFamily, 'contact__family--circle');
				} else {
					_.removeClass(contactFamily, 'contact__family--circle');
					_.addClass(contactFamily, 'contact__family--horizontal');
				}
			}
	
			if (contactFamily) {
				updateFamily();
				window.addEventListener('resize', updateFamily);
			}
		});
	})(window, document, little.qsa, little.qs, little.util);
	
	//Homepage video
	$(document).ready(function () {
	
		$('.playBtn').click(function () {
			$(".video").removeClass("hide");
		});
	
		var urlDump = $('#video').attr('src');
		var url = $('#video').attr('src');
	
		$('.playBtn').click(function () {
			$('#video').attr('src', urlDump);
			console.log(urlDump);
		});
	
		$('.hero__close').click(function () {
			$('#video').attr('src', '');
			console.log('asd');
			$(".video").addClass("hide");
		});
	
		var homePopup = document.querySelector('.overlay');
	
		// if(!Cookies.get('ModalCookie')) {
		if (homePopup) {
			homePopup.addEventListener('click', function () {
				this.classList.add('closed');
				setTimeout(function () {
					homePopup.classList.add('closed-z-index');
				}, 401);
				// if(!Cookies.get('ModalCookie')) {
				//     setCloseModalCookie();
				// }
			});
		}
		// }
	
	
		/*
	 Modal
	  */
		function setCloseModalCookie() {
	
			// Generate Random String
			var cookieValue = makeId();
			// Cookies.set('ModalCookie', cookieValue, { expires: 1, domain: 'calllanesocial.co.uk' });
			_jsCookie2.default.set('ModalCookie', cookieValue, { expires: 1, domain: 'localhost/call-lane-social' });
		}
	
		function makeId() {
			var text = "";
			var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	
			for (var i = 0; i < 10; i++) {
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			}return text;
		}
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else this[name] = definition();
	})('$script', function () {
	  var doc = document,
	      head = doc.getElementsByTagName('head')[0],
	      s = 'string',
	      f = false,
	      push = 'push',
	      readyState = 'readyState',
	      onreadystatechange = 'onreadystatechange',
	      list = {},
	      ids = {},
	      delay = {},
	      scripts = {},
	      scriptpath,
	      urlArgs;
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) {
	      if (!fn(ar[i])) return f;
	    }return 1;
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el);
	    });
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths];
	    var idOrDoneIsDone = idOrDone && idOrDone.call,
	        done = idOrDoneIsDone ? idOrDone : optDone,
	        id = idOrDoneIsDone ? paths.join('') : idOrDone,
	        queue = paths.length;
	    function loopFn(item) {
	      return item.call ? item() : list[item];
	    }
	    function callback() {
	      if (! --queue) {
	        list[id] = 1;
	        done && done();
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback();
	
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = path.indexOf('.js') === -1 ? scriptpath + path + '.js' : scriptpath + path;
	        }
	
	        if (scripts[path]) {
	          if (id) ids[id] = 1;
	          return scripts[path] == 2 ? callback() : setTimeout(function () {
	            loading(path, true);
	          }, 0);
	        }
	
	        scripts[path] = 1;
	        if (id) ids[id] = 1;
	        create(path, callback);
	      });
	    }, 0);
	    return $script;
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'),
	        loaded;
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if (el[readyState] && !/^c|loade/.test(el[readyState]) || loaded) return;
	      el.onload = el[onreadystatechange] = null;
	      loaded = 1;
	      scripts[path] = 2;
	      fn();
	    };
	    el.async = 1;
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild);
	  }
	
	  $script.get = create;
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift();
	      !scripts.length ? $script(s, id, done) : $script(s, callback);
	    })();
	  };
	
	  $script.path = function (p) {
	    scriptpath = p;
	  };
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  };
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps];
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {
	      return list[dep];
	    }) ? ready() : !function (key) {
	      delay[key] = delay[key] || [];
	      delay[key][push](ready);
	      req && req(missing);
	    }(deps.join('|'));
	    return $script;
	  };
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone);
	  };
	
	  return $script;
	});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  hey, [be]Lazy.js - v1.5.2 - 2015.12.01
	  A lazy loading and multi-serving image script
	  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
	*/
	;
	(function (root, blazy) {
	    if (true) {
	        // AMD. Register bLazy as an anonymous module
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = blazy();
	    } else {
	        // Browser globals. Register bLazy on window
	        root.Blazy = blazy();
	    }
	})(undefined, function () {
	    'use strict';
	
	    //private vars
	
	    var source, viewport, isRetina;
	
	    // constructor
	    return function Blazy(options) {
	        //IE7- fallback for missing querySelectorAll support
	        if (!document.querySelectorAll) {
	            var s = document.createStyleSheet();
	            document.querySelectorAll = function (r, c, i, j, a) {
	                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
	                for (i = r.length; i--;) {
	                    s.addRule(r[i], 'k:v');
	                    for (j = a.length; j--;) {
	                        a[j].currentStyle.k && c.push(a[j]);
	                    }s.removeRule(0);
	                }
	                return c;
	            };
	        }
	
	        //options and helper vars
	        var scope = this;
	        var util = scope._util = {};
	        util.elements = [];
	        util.destroyed = true;
	        scope.options = options || {};
	        scope.options.error = scope.options.error || false;
	        scope.options.offset = scope.options.offset || 100;
	        scope.options.success = scope.options.success || false;
	        scope.options.selector = scope.options.selector || '.b-lazy';
	        scope.options.separator = scope.options.separator || '|';
	        scope.options.container = scope.options.container ? document.querySelectorAll(scope.options.container) : false;
	        scope.options.errorClass = scope.options.errorClass || 'b-error';
	        scope.options.breakpoints = scope.options.breakpoints || false;
	        scope.options.loadInvisible = scope.options.loadInvisible || false;
	        scope.options.successClass = scope.options.successClass || 'b-loaded';
	        scope.options.validateDelay = scope.options.validateDelay || 25;
	        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
	        scope.options.src = source = scope.options.src || 'data-src';
	        isRetina = window.devicePixelRatio > 1;
	        viewport = {};
	        viewport.top = 0 - scope.options.offset;
	        viewport.left = 0 - scope.options.offset;
	
	        /* public functions
	         ************************************/
	        scope.revalidate = function () {
	            initialize(this);
	        };
	        scope.load = function (elements, force) {
	            var opt = this.options;
	            if (elements.length === undefined) {
	                loadElement(elements, force, opt);
	            } else {
	                each(elements, function (element) {
	                    loadElement(element, force, opt);
	                });
	            }
	        };
	        scope.destroy = function () {
	            var self = this;
	            var util = self._util;
	            if (self.options.container) {
	                each(self.options.container, function (object) {
	                    unbindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            unbindEvent(window, 'scroll', util.validateT);
	            unbindEvent(window, 'resize', util.validateT);
	            unbindEvent(window, 'resize', util.saveViewportOffsetT);
	            util.count = 0;
	            util.elements.length = 0;
	            util.destroyed = true;
	        };
	
	        //throttle, ensures that we don't call the functions too often
	        util.validateT = throttle(function () {
	            validate(scope);
	        }, scope.options.validateDelay, scope);
	        util.saveViewportOffsetT = throttle(function () {
	            saveViewportOffset(scope.options.offset);
	        }, scope.options.saveViewportOffsetDelay, scope);
	        saveViewportOffset(scope.options.offset);
	
	        //handle multi-served image src
	        each(scope.options.breakpoints, function (object) {
	            if (object.width >= window.screen.width) {
	                source = object.src;
	                return false;
	            }
	        });
	
	        // start lazy load
	        initialize(scope);
	    };
	
	    /* Private helper functions
	     ************************************/
	    function initialize(self) {
	        var util = self._util;
	        // First we create an array of elements to lazy load
	        util.elements = toArray(self.options.selector);
	        util.count = util.elements.length;
	        // Then we bind resize and scroll events if not already binded
	        if (util.destroyed) {
	            util.destroyed = false;
	            if (self.options.container) {
	                each(self.options.container, function (object) {
	                    bindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            bindEvent(window, 'resize', util.saveViewportOffsetT);
	            bindEvent(window, 'resize', util.validateT);
	            bindEvent(window, 'scroll', util.validateT);
	        }
	        // And finally, we start to lazy load. Should bLazy ensure domready?
	        validate(self);
	    }
	
	    function validate(self) {
	        var util = self._util;
	        for (var i = 0; i < util.count; i++) {
	            var element = util.elements[i];
	            if (elementInView(element) || hasClass(element, self.options.successClass)) {
	                self.load(element);
	                util.elements.splice(i, 1);
	                util.count--;
	                i--;
	            }
	        }
	        if (util.count === 0) {
	            self.destroy();
	        }
	    }
	
	    function elementInView(ele) {
	        var rect = ele.getBoundingClientRect();
	        return (
	            // Intersection
	            rect.right >= viewport.left && rect.bottom >= viewport.top && rect.left <= viewport.right && rect.top <= viewport.bottom
	        );
	    }
	
	    function loadElement(ele, force, options) {
	        // if element is visible, not loaded or forced
	        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || ele.offsetWidth > 0 && ele.offsetHeight > 0)) {
	            var dataSrc = ele.getAttribute(source) || ele.getAttribute(options.src); // fallback to default 'data-src'
	            if (dataSrc) {
	                var dataSrcSplitted = dataSrc.split(options.separator);
	                var src = dataSrcSplitted[isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
	                var isImage = ele.nodeName.toLowerCase() === 'img';
	                // cleanup markup, remove data source attributes
	                each(options.breakpoints, function (object) {
	                    ele.removeAttribute(object.src);
	                });
	                ele.removeAttribute(options.src);
	                if (isImage || ele.src === undefined) {
	                    var img = new Image();
	                    img.onerror = function () {
	                        if (options.error) options.error(ele, "invalid");
	                        addClass(ele, options.errorClass);
	                    };
	                    img.onload = function () {
	                        // Is element an image or should we add the src as a background image?
	                        isImage ? ele.src = src : ele.style.backgroundImage = 'url("' + src + '")';
	                        addClass(ele, options.successClass);
	                        if (options.success) options.success(ele);
	                    };
	                    img.src = src; //preload
	                } else {
	                    ele.src = src;
	                    addClass(ele, options.successClass);
	                }
	            } else {
	                if (options.error) options.error(ele, "missing");
	                if (!hasClass(ele, options.errorClass)) addClass(ele, options.errorClass);
	            }
	        }
	    }
	
	    function hasClass(ele, className) {
	        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    function addClass(ele, className) {
	        ele.className = ele.className + ' ' + className;
	    }
	
	    function toArray(selector) {
	        var array = [];
	        var nodelist = document.querySelectorAll(selector);
	        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
	        return array;
	    }
	
	    function saveViewportOffset(offset) {
	        viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
	        viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
	    }
	
	    function bindEvent(ele, type, fn) {
	        if (ele.attachEvent) {
	            ele.attachEvent && ele.attachEvent('on' + type, fn);
	        } else {
	            ele.addEventListener(type, fn, false);
	        }
	    }
	
	    function unbindEvent(ele, type, fn) {
	        if (ele.detachEvent) {
	            ele.detachEvent && ele.detachEvent('on' + type, fn);
	        } else {
	            ele.removeEventListener(type, fn, false);
	        }
	    }
	
	    function each(object, fn) {
	        if (object && fn) {
	            var l = object.length;
	            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
	        }
	    }
	
	    function throttle(fn, minDelay, scope) {
	        var lastCall = 0;
	        return function () {
	            var now = +new Date();
	            if (now - lastCall < minDelay) {
	                return;
	            }
	            lastCall = now;
	            fn.apply(scope, arguments);
	        };
	    }
	});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * JavaScript Cookie v2.1.4
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
	    var registeredInModuleLoader = false;
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        registeredInModuleLoader = true;
	    }
	    if (( false ? 'undefined' : _typeof(exports)) === 'object') {
	        module.exports = factory();
	        registeredInModuleLoader = true;
	    }
	    if (!registeredInModuleLoader) {
	        var OldCookies = window.Cookies;
	        var api = window.Cookies = factory();
	        api.noConflict = function () {
	            window.Cookies = OldCookies;
	            return api;
	        };
	    }
	})(function () {
	    function extend() {
	        var i = 0;
	        var result = {};
	        for (; i < arguments.length; i++) {
	            var attributes = arguments[i];
	            for (var key in attributes) {
	                result[key] = attributes[key];
	            }
	        }
	        return result;
	    }
	
	    function init(converter) {
	        function api(key, value, attributes) {
	            var result;
	            if (typeof document === 'undefined') {
	                return;
	            }
	
	            // Write
	
	            if (arguments.length > 1) {
	                attributes = extend({
	                    path: '/'
	                }, api.defaults, attributes);
	
	                if (typeof attributes.expires === 'number') {
	                    var expires = new Date();
	                    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
	                    attributes.expires = expires;
	                }
	
	                // We're using "expires" because "max-age" is not supported by IE
	                attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
	                try {
	                    result = JSON.stringify(value);
	                    if (/^[\{\[]/.test(result)) {
	                        value = result;
	                    }
	                } catch (e) {}
	
	                if (!converter.write) {
	                    value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	                } else {
	                    value = converter.write(value, key);
	                }
	
	                key = encodeURIComponent(String(key));
	                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
	                key = key.replace(/[\(\)]/g, escape);
	
	                var stringifiedAttributes = '';
	
	                for (var attributeName in attributes) {
	                    if (!attributes[attributeName]) {
	                        continue;
	                    }
	                    stringifiedAttributes += '; ' + attributeName;
	                    if (attributes[attributeName] === true) {
	                        continue;
	                    }
	                    stringifiedAttributes += '=' + attributes[attributeName];
	                }
	                return document.cookie = key + '=' + value + stringifiedAttributes;
	            }
	
	            // Read
	
	            if (!key) {
	                result = {};
	            }
	
	            // To prevent the for loop in the first place assign an empty array
	            // in case there are no cookies at all. Also prevents odd result when
	            // calling "get()"
	            var cookies = document.cookie ? document.cookie.split('; ') : [];
	            var rdecode = /(%[0-9A-Z]{2})+/g;
	            var i = 0;
	
	            for (; i < cookies.length; i++) {
	                var parts = cookies[i].split('=');
	                var cookie = parts.slice(1).join('=');
	
	                if (cookie.charAt(0) === '"') {
	                    cookie = cookie.slice(1, -1);
	                }
	
	                try {
	                    var name = parts[0].replace(rdecode, decodeURIComponent);
	                    cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
	
	                    if (this.json) {
	                        try {
	                            cookie = JSON.parse(cookie);
	                        } catch (e) {}
	                    }
	
	                    if (key === name) {
	                        result = cookie;
	                        break;
	                    }
	
	                    if (!key) {
	                        result[name] = cookie;
	                    }
	                } catch (e) {}
	            }
	
	            return result;
	        }
	
	        api.set = api;
	        api.get = function (key) {
	            return api.call(api, key);
	        };
	        api.getJSON = function () {
	            return api.apply({
	                json: true
	            }, [].slice.call(arguments));
	        };
	        api.defaults = {};
	
	        api.remove = function (key, attributes) {
	            api(key, '', extend(attributes, {
	                expires: -1
	            }));
	        };
	
	        api.withConverter = init;
	
	        return api;
	    }
	
	    return init(function () {});
	});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (window, document) {
	
		'use strict';
	
		/*----------------------------*\
	 	TODO:
	 	wrap() - wrap element(s) in a new container element
	 	unwrap()
	 	move() - move element(s)
	 \*----------------------------*/
	
		/*----------------------------*\
	 	Document Ready
	 	https://github.com/jfriend00/docReady
	 \*----------------------------*/
	
		var ready,
		    readyList = [],
		    readyFired = false,
		    readyEventHandlersInstalled = false;
	
		function onready() {
			if (!readyFired) {
				readyFired = true;
				for (var i = 0; i < readyList.length; i++) {
					readyList[i].fn.call(window, readyList[i].ctx);
				}
				readyList = [];
			}
		}
	
		function readyStateChange() {
			if (document.readyState === "complete") {
				onready();
			}
		}
	
		ready = function ready(callback, context) {
	
			if (readyFired) {
				setTimeout(function () {
					callback(context);
				}, 1);
				return;
			} else {
				readyList.push({ fn: callback, ctx: context });
			}
			if (document.readyState === "complete" || !document.attachEvent && document.readyState === "interactive") {
	
				setTimeout(onready, 1);
			} else if (!readyEventHandlersInstalled) {
	
				if (document.addEventListener) {
					document.addEventListener("DOMContentLoaded", onready, false);
					window.addEventListener("load", onready, false);
				} else {
					document.attachEvent("onreadystatechange", readyStateChange);
					window.attachEvent("onload", onready);
				}
				readyEventHandlersInstalled = true;
			}
		};
	
		/*----------------------------*\
	 	Query Selector Functions
	 \*----------------------------*/
		function qs(selector, context) {
			context = typeof context === 'undefined' ? document : context;
			return context.querySelector(selector);
		}
	
		function qsa(selector, context) {
			context = typeof context === 'undefined' ? document : context;
			return context.querySelectorAll(selector);
		}
	
		/*----------------------------*\
	 	Manipulation
	 \*----------------------------*/
		function remove(elem) {
			elem = elem.length ? elem : [elem];
			for (var i = 0; i < elem.length; i++) {
				elem[i].parentNode.removeChild(elem[i]);
			}
		}
	
		/*----------------------------*\
	 	Styles
	 \*----------------------------*/
		function windowWidth() {
			return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		}
	
		function windowHeight() {
			return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		}
	
		/*----------------------------*\
	 	Class Helper Functions
	 	Adapted from classie by desandro: https://github.com/desandro/classie
	 \*----------------------------*/
		var hasClass, addClass, removeClass;
	
		function classReg(className) {
			return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
		}
	
		if ('classList' in document.documentElement) {
			hasClass = function hasClass(elem, c) {
				return elem.classList.contains(c);
			};
			addClass = function addClass(elem, c) {
				elem = elem.length ? elem : [elem];
				for (var i = 0; i < elem.length; i++) {
					elem[i].classList.add(c);
				}
			};
			removeClass = function removeClass(elem, c) {
				elem = elem.length ? elem : [elem];
				for (var i = 0; i < elem.length; i++) {
					elem[i].classList.remove(c);
				}
			};
		} else {
			hasClass = function hasClass(elem, c) {
				return classReg(c).test(elem.className);
			};
			addClass = function addClass(elem, c) {
				elem = elem.length ? elem : [elem];
				for (var i = 0; i < elem.length; i++) {
					if (!hasClass(elem[i], c)) {
						elem[i].className = elem[i].className + ' ' + c;
					}
				}
			};
			removeClass = function removeClass(elem, c) {
				elem = elem.length ? elem : [elem];
				for (var i = 0; i < elem.length; i++) {
					elem[i].className = elem[i].className.replace(classReg(c), ' ');
				}
			};
		}
	
		function toggleClass(elem, c) {
			elem = elem.length ? elem : [elem];
			for (var i = 0; i < elem.length; i++) {
				var fn = hasClass(elem[i], c) ? removeClass : addClass;
				fn(elem[i], c);
			}
		}
	
		/*----------------------------*\
	 	Event Handlers
	 \*----------------------------*/
		function on(type, elem, selector, fn) {
	
			fn = typeof selector === 'function' ? selector : fn;
			elem = elem.length ? elem : [elem];
	
			function listener(e) {
	
				/* jshint validthis: true */
	
				if (typeof selector === 'string') {
	
					var target = e.target.closest(selector);
	
					if (target) {
	
						fn.apply(target, [e]);
					}
				} else {
	
					fn.apply(this, [e]);
				}
			}
	
			for (var i = 0; i < elem.length; i++) {
	
				elem[i].addEventListener(type, listener);
			}
		}
	
		window.little = {
			qs: qs,
			qsa: qsa,
			util: {
				ready: ready,
				remove: remove,
				windowWidth: windowWidth,
				windowHeight: windowHeight,
				addClass: addClass,
				removeClass: removeClass,
				toggleClass: toggleClass,
				hasClass: hasClass,
				on: on
			}
		};
	})(window, document);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
		var popupViewed = sessionStorage.getItem("popupViewed");
	
		if (!popupViewed) {
			$('body').addClass('popup--active');
			$('body').attr('data-popup-open', true);
		}
	
		$("[data-close-popup]").click(function (e) {
			// e.preventDefault();
			storePopupViewedProp();
		});
	
		function storePopupViewedProp() {
			$('body').removeClass('popup--active');
			$('body').removeAttr('data-popup-open', true);
			sessionStorage.setItem("popupViewed", true);
		}
	
		$(document).on('click', '[data-popup-open]', function () {
			storePopupViewedProp();
		});
	
		// $('body').on('click', '[data-popup-content]', function(e) {
		// 	e.stopPropagation();
		// });
	
		$(document).on('keyup', '[data-popup-open]', function (e) {
			e.keyCode === 27 ? storePopupViewedProp() : null;
		});
	});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * viewport-units-buggyfill v0.5.5
	 * @web: https://github.com/rodneyrehm/viewport-units-buggyfill/
	 * @author: Rodney Rehm - http://rodneyrehm.de/en/
	 */
	
	(function (root, factory) {
	  'use strict';
	
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like enviroments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.viewportUnitsBuggyfill = factory();
	  }
	})(undefined, function () {
	  'use strict';
	  /*global document, window, navigator, location, XMLHttpRequest, XDomainRequest*/
	
	  var initialized = false;
	  var options;
	  var userAgent = window.navigator.userAgent;
	  var viewportUnitExpression = /([+-]?[0-9.]+)(vh|vw|vmin|vmax)/g;
	  var forEach = [].forEach;
	  var dimensions;
	  var declarations;
	  var styleNode;
	  var isBuggyIE = /MSIE [0-9]\./i.test(userAgent);
	  var isOldIE = /MSIE [0-8]\./i.test(userAgent);
	  var isOperaMini = userAgent.indexOf('Opera Mini') > -1;
	
	  var isMobileSafari = /(iPhone|iPod|iPad).+AppleWebKit/i.test(userAgent) && function () {
	    // Regexp for iOS-version tested against the following userAgent strings:
	    // Example WebView UserAgents:
	    // * iOS Chrome on iOS8: "Mozilla/5.0 (iPad; CPU OS 8_1 like Mac OS X) AppleWebKit/600.1.4 (KHTML, like Gecko) CriOS/39.0.2171.50 Mobile/12B410 Safari/600.1.4"
	    // * iOS Facebook on iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D201 [FBAN/FBIOS;FBAV/12.1.0.24.20; FBBV/3214247; FBDV/iPhone6,1;FBMD/iPhone; FBSN/iPhone OS;FBSV/7.1.1; FBSS/2; FBCR/AT&T;FBID/phone;FBLC/en_US;FBOP/5]"
	    // Example Safari UserAgents:
	    // * Safari iOS8: "Mozilla/5.0 (iPhone; CPU iPhone OS 8_0 like Mac OS X) AppleWebKit/600.1.3 (KHTML, like Gecko) Version/8.0 Mobile/12A4345d Safari/600.1.4"
	    // * Safari iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A4449d Safari/9537.53"
	    var iOSversion = userAgent.match(/OS (\d)/);
	    // viewport units work fine in mobile Safari and webView on iOS 8+
	    return iOSversion && iOSversion.length > 1 && parseInt(iOSversion[1]) < 8;
	  }();
	
	  var isBadStockAndroid = function () {
	    // Android stock browser test derived from
	    // http://stackoverflow.com/questions/24926221/distinguish-android-chrome-from-stock-browser-stock-browsers-user-agent-contai
	    var isAndroid = userAgent.indexOf(' Android ') > -1;
	    if (!isAndroid) {
	      return false;
	    }
	
	    var isStockAndroid = userAgent.indexOf('Version/') > -1;
	    if (!isStockAndroid) {
	      return false;
	    }
	
	    var versionNumber = parseFloat((userAgent.match('Android ([0-9.]+)') || [])[1]);
	    // anything below 4.4 uses WebKit without *any* viewport support,
	    // 4.4 has issues with viewport units within calc()
	    return versionNumber <= 4.4;
	  }();
	
	  // added check for IE11, since it *still* doesn't understand vmax!!!
	  if (!isBuggyIE) {
	    isBuggyIE = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
	  }
	
	  // Polyfill for creating CustomEvents on IE9/10/11
	  // from https://github.com/krambuhl/custom-event-polyfill
	  try {
	    new CustomEvent('test');
	  } catch (e) {
	    var CustomEvent = function CustomEvent(event, params) {
	      var evt;
	      params = params || {
	        bubbles: false,
	        cancelable: false,
	        detail: undefined
	      };
	
	      evt = document.createEvent('CustomEvent');
	      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	      return evt;
	    };
	    CustomEvent.prototype = window.Event.prototype;
	    window.CustomEvent = CustomEvent; // expose definition to window
	  }
	
	  function debounce(func, wait) {
	    var timeout;
	    return function () {
	      var context = this;
	      var args = arguments;
	      var callback = function callback() {
	        func.apply(context, args);
	      };
	
	      clearTimeout(timeout);
	      timeout = setTimeout(callback, wait);
	    };
	  }
	
	  // from http://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
	  function inIframe() {
	    try {
	      return window.self !== window.top;
	    } catch (e) {
	      return true;
	    }
	  }
	
	  function initialize(initOptions) {
	    if (initialized) {
	      return;
	    }
	
	    if (initOptions === true) {
	      initOptions = {
	        force: true
	      };
	    }
	
	    options = initOptions || {};
	    options.isMobileSafari = isMobileSafari;
	    options.isBadStockAndroid = isBadStockAndroid;
	
	    if (isOldIE || !options.force && !isMobileSafari && !isBuggyIE && !isBadStockAndroid && !isOperaMini && (!options.hacks || !options.hacks.required(options))) {
	      // this buggyfill only applies to mobile safari, IE9-10 and the Stock Android Browser.
	      if (window.console && isOldIE) {
	        console.info('viewport-units-buggyfill requires a proper CSSOM and basic viewport unit support, which are not available in IE8 and below');
	      }
	
	      return {
	        init: function init() {}
	      };
	    }
	
	    // fire a custom event that buggyfill was initialize
	    window.dispatchEvent(new CustomEvent('viewport-units-buggyfill-init'));
	
	    options.hacks && options.hacks.initialize(options);
	
	    initialized = true;
	    styleNode = document.createElement('style');
	    styleNode.id = 'patched-viewport';
	    document.head.appendChild(styleNode);
	
	    // Issue #6: Cross Origin Stylesheets are not accessible through CSSOM,
	    // therefore download and inject them as <style> to circumvent SOP.
	    importCrossOriginLinks(function () {
	      var _refresh = debounce(refresh, options.refreshDebounceWait || 100);
	      // doing a full refresh rather than updateStyles because an orientationchange
	      // could activate different stylesheets
	      window.addEventListener('orientationchange', _refresh, true);
	      // orientationchange might have happened while in a different window
	      window.addEventListener('pageshow', _refresh, true);
	
	      if (options.force || isBuggyIE || inIframe()) {
	        window.addEventListener('resize', _refresh, true);
	        options._listeningToResize = true;
	      }
	
	      options.hacks && options.hacks.initializeEvents(options, refresh, _refresh);
	
	      refresh();
	    });
	  }
	
	  function updateStyles() {
	    styleNode.textContent = getReplacedViewportUnits();
	    // move to the end in case inline <style>s were added dynamically
	    styleNode.parentNode.appendChild(styleNode);
	    // fire a custom event that styles were updated
	    window.dispatchEvent(new CustomEvent('viewport-units-buggyfill-style'));
	  }
	
	  function refresh() {
	    if (!initialized) {
	      return;
	    }
	
	    findProperties();
	
	    // iOS Safari will report window.innerWidth and .innerHeight as 0 unless a timeout is used here.
	    // TODO: figure out WHY innerWidth === 0
	    setTimeout(function () {
	      updateStyles();
	    }, 1);
	  }
	
	  function findProperties() {
	    declarations = [];
	    forEach.call(document.styleSheets, function (sheet) {
	      if (sheet.ownerNode.id === 'patched-viewport' || !sheet.cssRules || sheet.ownerNode.getAttribute('data-viewport-units-buggyfill') === 'ignore') {
	        // skip entire sheet because no rules are present, it's supposed to be ignored or it's the target-element of the buggyfill
	        return;
	      }
	
	      if (sheet.media && sheet.media.mediaText && window.matchMedia && !window.matchMedia(sheet.media.mediaText).matches) {
	        // skip entire sheet because media attribute doesn't match
	        return;
	      }
	
	      forEach.call(sheet.cssRules, findDeclarations);
	    });
	
	    return declarations;
	  }
	
	  function findDeclarations(rule) {
	    if (rule.type === 7) {
	      var value;
	
	      // there may be a case where accessing cssText throws an error.
	      // I could not reproduce this issue, but the worst that can happen
	      // this way is an animation not running properly.
	      // not awesome, but probably better than a script error
	      // see https://github.com/rodneyrehm/viewport-units-buggyfill/issues/21
	      try {
	        value = rule.cssText;
	      } catch (e) {
	        return;
	      }
	
	      viewportUnitExpression.lastIndex = 0;
	      if (viewportUnitExpression.test(value)) {
	        // KeyframesRule does not have a CSS-PropertyName
	        declarations.push([rule, null, value]);
	        options.hacks && options.hacks.findDeclarations(declarations, rule, null, value);
	      }
	
	      return;
	    }
	
	    if (!rule.style) {
	      if (!rule.cssRules) {
	        return;
	      }
	
	      forEach.call(rule.cssRules, function (_rule) {
	        findDeclarations(_rule);
	      });
	
	      return;
	    }
	
	    forEach.call(rule.style, function (name) {
	      var value = rule.style.getPropertyValue(name);
	      // preserve those !important rules
	      if (rule.style.getPropertyPriority(name)) {
	        value += ' !important';
	      }
	
	      viewportUnitExpression.lastIndex = 0;
	      if (viewportUnitExpression.test(value)) {
	        declarations.push([rule, name, value]);
	        options.hacks && options.hacks.findDeclarations(declarations, rule, name, value);
	      }
	    });
	  }
	
	  function getReplacedViewportUnits() {
	    dimensions = getViewport();
	
	    var css = [];
	    var buffer = [];
	    var open;
	    var close;
	
	    declarations.forEach(function (item) {
	      var _item = overwriteDeclaration.apply(null, item);
	      var _open = _item.selector.length ? _item.selector.join(' {\n') + ' {\n' : '';
	      var _close = new Array(_item.selector.length + 1).join('\n}');
	
	      if (!_open || _open !== open) {
	        if (buffer.length) {
	          css.push(open + buffer.join('\n') + close);
	          buffer.length = 0;
	        }
	
	        if (_open) {
	          open = _open;
	          close = _close;
	          buffer.push(_item.content);
	        } else {
	          css.push(_item.content);
	          open = null;
	          close = null;
	        }
	
	        return;
	      }
	
	      if (_open && !open) {
	        open = _open;
	        close = _close;
	      }
	
	      buffer.push(_item.content);
	    });
	
	    if (buffer.length) {
	      css.push(open + buffer.join('\n') + close);
	    }
	
	    // Opera Mini messes up on the content hack (it replaces the DOM node's innerHTML with the value).
	    // This fixes it. We test for Opera Mini only since it is the most expensive CSS selector
	    // see https://developer.mozilla.org/en-US/docs/Web/CSS/Universal_selectors
	    if (isOperaMini) {
	      css.push('* { content: normal !important; }');
	    }
	
	    return css.join('\n\n');
	  }
	
	  function overwriteDeclaration(rule, name, value) {
	    var _value;
	    var _selectors = [];
	
	    _value = value.replace(viewportUnitExpression, replaceValues);
	
	    if (options.hacks) {
	      _value = options.hacks.overwriteDeclaration(rule, name, _value);
	    }
	
	    if (name) {
	      // skipping KeyframesRule
	      _selectors.push(rule.selectorText);
	      _value = name + ': ' + _value + ';';
	    }
	
	    var _rule = rule.parentRule;
	    while (_rule) {
	      _selectors.unshift('@media ' + _rule.media.mediaText);
	      _rule = _rule.parentRule;
	    }
	
	    return {
	      selector: _selectors,
	      content: _value
	    };
	  }
	
	  function replaceValues(match, number, unit) {
	    var _base = dimensions[unit];
	    var _number = parseFloat(number) / 100;
	    return _number * _base + 'px';
	  }
	
	  function getViewport() {
	    var vh = window.innerHeight;
	    var vw = window.innerWidth;
	
	    return {
	      vh: vh,
	      vw: vw,
	      vmax: Math.max(vw, vh),
	      vmin: Math.min(vw, vh)
	    };
	  }
	
	  function importCrossOriginLinks(next) {
	    var _waiting = 0;
	    var decrease = function decrease() {
	      _waiting--;
	      if (!_waiting) {
	        next();
	      }
	    };
	
	    forEach.call(document.styleSheets, function (sheet) {
	      if (!sheet.href || origin(sheet.href) === origin(location.href) || sheet.ownerNode.getAttribute('data-viewport-units-buggyfill') === 'ignore') {
	        // skip <style> and <link> from same origin or explicitly declared to ignore
	        return;
	      }
	
	      _waiting++;
	      convertLinkToStyle(sheet.ownerNode, decrease);
	    });
	
	    if (!_waiting) {
	      next();
	    }
	  }
	
	  function origin(url) {
	    return url.slice(0, url.indexOf('/', url.indexOf('://') + 3));
	  }
	
	  function convertLinkToStyle(link, next) {
	    getCors(link.href, function () {
	      var style = document.createElement('style');
	      style.media = link.media;
	      style.setAttribute('data-href', link.href);
	      style.textContent = this.responseText;
	      link.parentNode.replaceChild(style, link);
	      next();
	    }, next);
	  }
	
	  function getCors(url, success, error) {
	    var xhr = new XMLHttpRequest();
	    if ('withCredentials' in xhr) {
	      // XHR for Chrome/Firefox/Opera/Safari.
	      xhr.open('GET', url, true);
	    } else if (typeof XDomainRequest !== 'undefined') {
	      // XDomainRequest for IE.
	      xhr = new XDomainRequest();
	      xhr.open('GET', url);
	    } else {
	      throw new Error('cross-domain XHR not supported');
	    }
	
	    xhr.onload = success;
	    xhr.onerror = error;
	    xhr.send();
	    return xhr;
	  }
	
	  return {
	    version: '0.5.5',
	    findProperties: findProperties,
	    getCss: getReplacedViewportUnits,
	    init: initialize,
	    refresh: refresh
	  };
	});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	$(document).ready(function () {
	    var _$$slick;
	
	    jQuery('[data-social-slider-arrow="prev"]').addClass('slick-arrow--active');
	    jQuery('[data-social-slider-arrow="next"]').addClass('slick-arrow--active');
	
	    $('[data-social-slider]').slick((_$$slick = {
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        infinite: false,
	        nextArrow: jQuery('[data-social-slider-arrow="next"'),
	        prevArrow: jQuery('[data-social-slider-arrow="prev"')
	    }, _defineProperty(_$$slick, 'infinite', true), _defineProperty(_$$slick, 'responsive', [{
	        breakpoint: 1025,
	        settings: {
	            slidesToShow: 3,
	            slidesToScroll: 1
	        }
	    }, {
	        breakpoint: 768,
	        settings: {
	            slidesToShow: 2,
	            slidesToScroll: 1
	        }
	    }]), _$$slick));
	});

/***/ })
/******/ ]);
